import React from 'react';
import TrackingDetail from './TrackingDetail';
import TrackingSummary from './TrackingSummary';

const Tracking = ({ details }) => (
  <>
    <TrackingSummary />
    <TrackingDetail details={details} />
  </>
);

export default Tracking;
